<template>
  <div ref="fisrtScreen" class="open-top-img">
    <img :src="topBg" style="width:100%;" alt="">
      <div class="textBox" >
        <LazyLoading>
          <div class="text goUp">
            <h1 class="title">打造属于自己公司的智能门禁管理系统</h1>
            <h2
              class="descript"
            >NOVOBIT开放平台包括门禁硬件与云端管理系统两部分，开放云端API接口便于开发者将门禁系统与自身业务系统进行集成，以满足开发者的独立应用场景。</h2>
<!--            <div class="btn"><a href="https://oapi.novoiot.com/help/docs/" target="_blank" style="color:#fff;">查看开发文档</a></div>-->
          </div>
         </LazyLoading>
      </div>

  </div>
</template>

<script>
import { debug } from "util";
import {LazyLoading} from 'novo-ui'

export default {

  components: {
    LazyLoading
  },
  data() {
    return {
      homeVideoA1: false,
       topBg: require("common/image/open-platform/top-bg.png"),
    };
  },
  mounted() {
    let dom = this.$refs['fisrtScreen'];
    let winH =  document.documentElement.clientHeight;
    console.log("winH",winH)
    dom.style.height=winH+'px'
    setTimeout(() => {
      this.homeVideoA1 = true;
    }, 500);
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.open-top-img {
  position: relative;
  min-height: 660px;
  font-size: 0;
  overflow: hidden;
  .textBox {
    // visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // padding-top: 238px;
    background: rgba(255, 255, 255, 0.5);
    .text {
      position: absolute;
      width: 1050px;
      top: 50%;
      left: 50%;
      // transform: translate(-50%, -50%);
      margin-left:-525px;
      // width: 100%;
      margin-top: -148px;
    }
    h1,
    h2 {
      text-align: center;
      font-weight: 400;
    }
    .btn {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      width: 180px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background-image: linear-gradient(-135deg,  #3ca9ff 0%,  #7ce1ff 100%);
      border-radius: 30px;
      font-family: DFPKingGothicGB-Medium;
      font-size: 24px;
      color: #ffffff;
      cursor: pointer;
    }
    .title {
      font-family: DFPKingGothicGB-Regular;
      font-size: 36px;
      color: #323232;
      text-align: center;
      height: 44px;
      line-height: 44px;
      margin-bottom: 35px;
      font-weight: bold;
    }
    .descript {
      font-family: DFPKingGothicGB-Regular;
      font-size: 24px;
      color: #000000;
      text-align: center;
      line-height: 50px;
      margin-bottom: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/open-platform/top-vedio.vue